import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/operators'
import Component from 'components/Operators/Select'

export default createListModalContainer({ actions })(Component)
